import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { Box, Paper, Typography, Avatar } from '@mui/material';
import { CallSplit as RouterIcon } from '@mui/icons-material';

const RouterNode = ({ data, selected }) => {
  return (
    <Paper
      elevation={selected ? 8 : 2}
      sx={{
        padding: '12px 16px',
        borderRadius: 2,
        border: '2px solid',
        borderColor: selected ? 'primary.main' : '#9c27b0',
        backgroundColor: selected ? 'primary.light' : '#f3e5f5',
        minWidth: 180,
        transition: 'all 0.2s'
      }}
    >
      <Handle
        type="target"
        position={Position.Top}
        style={{ background: '#9c27b0', width: 10, height: 10 }}
      />
      
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Avatar sx={{ width: 28, height: 28, backgroundColor: '#9c27b0', color: 'white' }}>
          <RouterIcon fontSize="small" />
        </Avatar>
        <Typography variant="caption" sx={{ color: '#9c27b0', fontWeight: 600 }}>
          ROUTER
        </Typography>
      </Box>
      
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {data.label || 'Router'}
      </Typography>
      
      <Handle
        type="source"
        position={Position.Bottom}
        style={{ background: '#9c27b0', width: 10, height: 10 }}
      />
    </Paper>
  );
};

export default memo(RouterNode);